import React from 'react';
import Icon from '../../../components/AppIcon';

const TravelStatsCard = ({ stats }) => {
  const statItems = [
    {
      id: 'totalTrips',
      label: 'Total Trips',
      value: stats.totalTrips,
      icon: 'Plane',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      id: 'favoriteDestinations',
      label: 'Favorite Destinations',
      value: stats.favoriteDestinations,
      icon: 'MapPin',
      color: 'text-secondary',
      bgColor: 'bg-secondary/10'
    },
    {
      id: 'loyaltyPoints',
      label: 'Loyalty Points',
      value: stats.loyaltyPoints.toLocaleString('en-IN'),
      icon: 'Award',
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    },
    {
      id: 'savedAmount',
      label: 'Total Saved',
      value: `₹${stats.savedAmount.toLocaleString('en-IN')}`,
      icon: 'Wallet',
      color: 'text-success',
      bgColor: 'bg-success/10'
    }
  ];

  return (
    <div className="bg-card rounded-xl border border-border p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-heading font-semibold text-foreground">
          Travel Statistics
        </h3>
        <Icon name="TrendingUp" size={20} className="text-muted-foreground" />
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {statItems.map((item) => (
          <div key={item.id} className="text-center">
            <div className={`w-12 h-12 ${item.bgColor} rounded-lg flex items-center justify-center mx-auto mb-3`}>
              <Icon name={item.icon} size={24} className={item.color} />
            </div>
            <p className="text-2xl font-heading font-bold text-foreground mb-1">
              {item.value}
            </p>
            <p className="text-sm text-muted-foreground font-caption">
              {item.label}
            </p>
          </div>
        ))}
      </div>

      <div className="mt-6 pt-6 border-t border-border">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-foreground mb-1">
              Next Loyalty Tier
            </p>
            <p className="text-xs text-muted-foreground">
              {stats.loyaltyPoints >= 10000 ? 'Platinum Member' : 
               stats.loyaltyPoints >= 5000 ? 'Gold Member' : 'Silver Member'}
            </p>
          </div>
          <div className="text-right">
            <p className="text-sm font-medium text-foreground mb-1">
              Progress
            </p>
            <div className="flex items-center space-x-2">
              <div className="w-20 bg-muted rounded-full h-2">
                <div 
                  className="bg-primary h-2 rounded-full transition-all duration-300"
                  style={{ 
                    width: `${Math.min((stats.loyaltyPoints % 5000) / 5000 * 100, 100)}%` 
                  }}
                />
              </div>
              <span className="text-xs text-muted-foreground">
                {Math.min((stats.loyaltyPoints % 5000) / 5000 * 100, 100).toFixed(0)}%
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TravelStatsCard;